import React from 'react';
import { injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
// import axios from 'axios';
import { get } from 'lodash';
import { LayoutWithStepper } from 'layouts';
import {
  PageContentWrapper, PaymentDetail, FooterAction,
} from 'components';
import apiRequest from 'shared/services/api';
import selectors from 'shared/store/selectors';
import utils from 'shared/helpers/utils';
import { PATH } from 'shared/constant';
import { applicantAction } from 'shared/store/actions';

// const source = axios.CancelToken.source();

function PaymentSuccess({
  intl, history, token, product, onUpdateHistory,
}) {
  const [paymentData, setPaymentData] = React.useState([]);
  // const abortController = new AbortController();
  const search = history.location?.search;

  React.useEffect(() => {
    const queryStr = new URLSearchParams(search);
    const getData = queryStr.get('data');
    const parseData = async (data) => {
      try {
        const res = await apiRequest.parsePaymentResult(token, data, product);
        const resData = res.response;
        const details = [
          { label: intl.formatMessage({ id: 'payment.amtPaid' }), value: `${get(resData, 'variable3')} ${utils.formatNumberToDecimal(get(resData, 'amount'))}` },
          { label: intl.formatMessage({ id: 'payment.id' }), value: get(resData, 'paymentId') },
          { label: intl.formatMessage({ id: 'payment.paidOn' }), value: get(resData, 'paidOn') },
        ];
        setPaymentData(details);

        // record history on MO
        const code = 'NW-PMT-SUS';
        const codeI18n = 'nw.markaz.middle_office.action_type.payment_success';
        onUpdateHistory(code, codeI18n);
      } catch (err) {
        console.error(err);
        toast.error('Oops, something went wrong.');
      }
    };

    if (getData) parseData(getData);

    // return () => {
    //   // source.cancel();
    //   abortController.abort();
    // };
  }, [search, intl, token, product, onUpdateHistory]);

  return (
    <PageContentWrapper isWithPadding>
      <div className="content-container content-container--withPadding">
        {/* <p className="content-container__para">{intl.formatMessage({ id: 'payment.desc' })}</p> */}
        <PaymentDetail
          title={intl.formatMessage({ id: 'payment.success' })}
          data={paymentData}
          isDisabled={false}
        />
      </div>

      <FooterAction
        isSingleButton
        rightButton={intl.formatMessage({ id: 'payment.contiueToLegalDocs' })}
        isDisabled={false}
        onRightButtonClick={() => history.push(PATH.PRINT_CHECKLIST)}
      />
    </PageContentWrapper>
  );
}

const mapStateToProps = state => ({
  token: selectors.getToken(state),
  product: selectors.getProduct(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateHistory: (code, codeI18n) => dispatch(applicantAction.updateHistory(code, codeI18n)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutWithStepper(injectIntl(PaymentSuccess)));
